

export class DesignationOutputWithoutStatus implements IDesignationOutputWithoutStatus {
    /** The auto-generated id of the designation master */
    designation_id!: number;
    /** The designation name with 255 character limit */
    designation_name!: string;

    constructor(data?: IDesignationOutputWithoutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.designation_id = _data["designation_id"];
            this.designation_name = _data["designation_name"];
        }
    }

    static fromJS(data: any): DesignationOutputWithoutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new DesignationOutputWithoutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["designation_id"] = this.designation_id;
        data["designation_name"] = this.designation_name;
        return data; 
    }
}

export interface IDesignationOutputWithoutStatus {
    /** The auto-generated id of the designation master */
    designation_id: number;
    /** The designation name with 255 character limit */
    designation_name: string;
}

